module.exports = __webpack_public_path__ + "782bd363650890555e35e32414c27da9.png";